<button class="close icon icon-cross icon-size-16"
        mat-button
        (click)="close()"
        [attr.aria-label]="'Fermer' | transloco">
</button>
<mat-dialog-content>
    <div class="display-partner">
        <div class="display-partner__header">
            <app-header-invitation-b2b-partnership-logos [invitation]="data.invitation"
                                                         [onlyClient]="true"
                                                         class="margin-bottom-20">
            </app-header-invitation-b2b-partnership-logos>
            <div class="display-partner__header--name" *ngIf="hasName">
                {{data.invitation.extras.partner.name}}
            </div>
            <div class="display-partner__header--from">
                {{'Partenaire Infomaniak depuis le $from$' | transloco : { from: data.invitation.extras.partner.created_at * 1000 | dynamicDate:'shortDate' } }}
            </div>
        </div>
        <div class="display-partner__contact">
            <div class="contact" *ngIf="hasEmail">
                <div class="contact__title">
                    {{ 'Adresse mail' | transloco }}
                </div>
                <div class="contact__text">
                    <a [href]="'mailto:'+data.invitation.extras.partner.email"
                       class="link blue">
                        {{ data.invitation.extras.partner.email }}
                    </a>
                </div>
            </div>
            <div class="contact" *ngIf="hasAddresse">
                <div class="contact__title">
                    {{ 'Adresse' | transloco }}
                </div>
                <div class="contact__text">
                    {{ data.invitation.extras.partner.addresses[0].street_display }} -
                    {{ data.invitation.extras.partner.addresses[0].zip_code }}&nbsp;{{ data.invitation.extras.partner.addresses[0].city}}
                    - {{ data.invitation.extras.partner.addresses[0].country }}
                </div>
            </div>
            <div class="contact" *ngIf="hasSkills">
                <div class="contact__title">
                    {{ 'Domaines d\'activites' | transloco }}
                </div>
                <div class="contact__text">
                    <span *ngFor="let item of data.invitation.extras.partner.skills; let l = count; let i = index;">
                        {{item.label | transloco }}<span *ngIf="l !== i+1">,</span></span>
                </div>
            </div>
            <div class="contact" *ngIf="hasDescription">
                <div class="contact__title">
                    {{ 'Description du partenaire' | transloco }}
                </div>
                <div class="contact__text desc" [innerHtml]="partnerDescription">
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<div class="mat-dialog-footer">
    <div class="block-buttons clearfix">
        <button mat-flat-button
                (click)="close()"
                [attr.aria-label]="'Fermer' | transloco"
                color="accent">
            {{ 'Fermer' | transloco }}
        </button>
    </div>
</div>
